export enum ColorsEnum {
    black = 'black',
    orange = 'orange',
    lightBlue = 'light-blue',
    green = 'green',
    yellow = 'yellow',
    pink = 'pink',
    magenta = 'magenta'
}
